/**
 * /dashboard/skills — redirects to Settings → Skill catalog (SOP §8.3).
 *
 * For now the only skills surface in the product IS the catalog admin;
 * if a dedicated employee-skills page ships later this stub points
 * there. The redirect happens before the route loads so the Skills
 * sidebar entry — even though Phase 3a only ports the minimal stub —
 * lands users in the right place rather than 404.
 *
 * Migration note (2026-06-01, Next.js → Vite): port of
 * frontend/src/app/(dashboard)/dashboard/skills/page.tsx (which used
 * next/navigation `redirect()` server-side). The Vite SPA can't
 * server-redirect; we use TanStack Router's `beforeLoad` hook to throw
 * a redirect, which is the recommended client-side equivalent.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

// The destination route ships in a later Settings phase. Declared as a
// runtime string (not a literal) so it bypasses TanStack's strict typed-
// redirect check — the same pattern the sidebar uses for forward
// destinations. Once /dashboard/settings/skills is registered we can
// switch this back to a typed `to`.
const SKILLS_CATALOG_HREF: string = "/app/$tenantSlug/settings/skills";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/skills")({
  beforeLoad: () => {
    // 307-equivalent: preserve the user's intent, drop the /skills
    // entry from history so back-button doesn't loop.
    throw redirect({
      to: SKILLS_CATALOG_HREF,
      replace: true,
    });
  },
});
